import { Row, Col } from 'antd';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT, TIME_FORMAT_SHORT } from '../../utils/constants/domain-constants';
import { useWindowDimensions } from '../../hooks/useWindowDimensions';

interface Props {
    address?: string;
    routeEta?: string;
    remainingDistance?: number;
    name?: string;
    logoUrl?: string;
    isPromoVisible: boolean;
}

const EtaShareInfo = (props: Props) => {
    const { t } = useTranslation();
    const { width } = useWindowDimensions();

    const remainingTime = props.routeEta && moment(props.routeEta).diff(moment());
    const remainingTimeDurationFormat =
        remainingTime && remainingTime > 0
            ? `${moment.duration(remainingTime).days() ? moment.duration(remainingTime).days() + 'd' : ''} ${
                  moment.duration(remainingTime).hours() ? moment.duration(remainingTime).hours() + 'h' : ''
              } ${moment.duration(remainingTime).minutes() ? moment.duration(remainingTime).minutes() + 'm' : ''}`
            : 0;

    return (
        <div className="eta-share-info-wrapper" style={{ width: props.isPromoVisible ? width / 2 : '100%' }}>
            <div className="eta-share-info">
                <Row gutter={[10, 20]} align="middle">
                    <Col span="auto" style={{ marginBottom: '16px' }}>
                        <img src={props.logoUrl} alt="Logo" width={35} />
                    </Col>
                    <Col span="auto" className="eta-share-info-share" style={{ marginBottom: '16px' }}>
                        <b>{props.name} </b>
                        <span>{t('EtaShareInfo.isSharingEta')}</span>
                    </Col>
                    <Col span={24}>
                        <p className="eta-share-info-destination">{t('EtaShareInfo.destination')}</p>
                        <b className="eta-share-info-address">{props.address || 'N/A'}</b>
                    </Col>
                    <Col span={24}>
                        <Row className="eta-share-info-values" gutter={[0, 10]}>
                            <Col span={24} lg={10}>
                                <p className="eta-share-info-arrival">{t('EtaShareInfo.arrival')}</p>
                                <b className="eta-share-info-time">
                                    {moment(props.routeEta).format(TIME_FORMAT_SHORT)}*
                                </b>
                                <span className="eta-share-info-date">
                                    ({moment(props.routeEta).format(DATE_FORMAT)})
                                </span>
                            </Col>
                            <Col span={24} lg={7}>
                                <p className="eta-share-info-km">{t('EtaShareInfo.km')}</p>
                                <b className="eta-share-info-distance">
                                    {props.remainingDistance ? (props.remainingDistance / 1000).toFixed(0) : 0}
                                </b>
                            </Col>
                            <Col span={24} lg={7}>
                                <p className="eta-share-info-timeleft">{t('EtaShareInfo.timeLeft')}</p>
                                <b className="eta-share-info-duration">{remainingTimeDurationFormat}</b>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <p className="eta-share-info-note">{t('EtaShareInfo.note')}</p>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default EtaShareInfo;
